module.exports = __webpack_public_path__ + "static/46gde-cdb7402ff4a07f45d4b09614f6c3c34f.gif";